import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BaseSelect, { propsModelValue } from '@/components/BaseSelect.vue'
import { Ref, computed, PropType } from 'vue'
import { useCountryQuery } from '@/queries/countries'
import { Country, CountryFilters } from '@/models/settings.model'
import { Option } from '@/models/shared.model'


export default /*#__PURE__*/_defineComponent({
  __name: 'CountrySelect',
  props: {
  modelValue: propsModelValue,
  name: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
    default: undefined,
  },
  euMembers: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  errors: {
    type: Array as PropType<string[]>,
    default: () => [],
  },
},
  emits: ['select', 'update:modelValue'],
  setup(__props, { emit: emits }) {

const props = __props



const params: Ref<CountryFilters> = computed(() =>
  props.euMembers ? { is_eu_member: true } : {},
)
const { data: countries } = useCountryQuery(params.value)

const options = computed<number[]>(() => {
  return countries.value?.map((item: Country) => item.id) ?? []
})

const getOptionLabel = (option: number) => {
  const country: Country | undefined = (countries.value ?? []).find(
    (country: Country) => option === country.id,
  )

  return country?.name ?? option
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseSelect, {
    "model-value": __props.modelValue,
    label: __props.label,
    placeholder: __props.placeholder,
    options: _unref(options),
    name: __props.name,
    "close-on-select": "",
    disabled: __props.disabled,
    errors: __props.errors,
    "custom-label": getOptionLabel,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = (selected) => {
       _ctx.$emit('select', selected)
       _ctx.$emit('update:modelValue', selected)
    })
  }, null, 8, ["model-value", "label", "placeholder", "options", "name", "disabled", "errors"]))
}
}

})